export const processRow = (row) => {
  let finalVal = "";
  for (let j = 0; j < Object.keys(row).length; j++) {
    let innerValue = row[Object.keys(row)[j]] ? row[Object.keys(row)[j]].toString() : "";
    if (row[Object.keys(row)[j]] instanceof Date) {
      innerValue = row[Object.keys(row)[j]].toLocaleString();
    }
    let result = innerValue.replace(/"/g, '""');
    if (result.search(/("|,|\n)/g) >= 0) result = '"' + result + '"';
    if (j > 0) finalVal += ",";
    finalVal += result;
  }
  return finalVal + "\n";
};

export const processHeader = (row) => {
  const finalVal = Object.keys(row).join(",");
  return finalVal + "\n";
};

export const downloadCSV = (content, filename) => {
  const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, filename);
  } else {
    var link = document.createElement("a");
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", filename);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};

/*
Parse CSV row

Example usage:
Input - 'e1234,,"firstName, lastName",,'
Output - ['e1234', '', 'firstName, lastName', '', '']
*/
export const parseCSVRow = (row) => {
  const values = [];
  let current = "";
  let inQuotes = false;

  for (const char of row) {
    if (char === '"') {
      inQuotes = !inQuotes;
    } else if (char === "," && !inQuotes) {
      values.push(current);
      current = "";
    } else {
      current += char;
    }
  }

  values.push(current);
  return values;
};
